import axios from "axios";
import { SLEDGEHAMMER_BASE_API } from "../config";

const CACHE_KEY = 'termsCache';
const ONE_DAY = 1000 * 60 * 60 * 24;

export async function getTermsWithCache() {
  const cached = localStorage.getItem(CACHE_KEY);
  const now = Date.now();
  const baseUrl = SLEDGEHAMMER_BASE_API;

  if (cached) {
    const parsed = JSON.parse(cached);
    if (now - parsed.timestamp < ONE_DAY) {
      return parsed.data;
    }
  }

  const res = await axios(`${baseUrl}/dashboard/terms`);
  const data = res.data;

  localStorage.setItem(
    CACHE_KEY,
    JSON.stringify({
      data,
      timestamp: now,
    })
  );

  return data;
}

export function clearTermsCache() {
  localStorage.removeItem(CACHE_KEY);
}
